import { Link } from "@tanstack/react-router";
import { BrandLogo, Numeric } from "@/shared/components";

/**
 * Auth 전용 레이아웃 — 로그인, 회원가입, 비밀번호 등
 * 사이드바 없이 중앙 정렬된 카드 폼 제공
 */
export function AuthLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-surface-base">
      {/* Header */}
      <header className="flex h-14 shrink-0 items-center border-b border-stroke-subtle bg-surface-raised px-6">
        <Link to="/" className="flex items-center gap-2">
          <BrandLogo className="size-5 text-text-brand" />
          <Numeric className="text-[14px] font-bold tracking-tight">
            datalab<span className="text-text-brand">.tools</span>
          </Numeric>
        </Link>
      </header>

      {/* Center content */}
      <main className="flex flex-1 items-center justify-center p-6">
        <div className="w-full max-w-md">{children}</div>
      </main>

      {/* Footer */}
      <footer className="border-t border-stroke-subtle py-4 text-center text-[11px] text-text-tertiary">
        &copy; {new Date().getFullYear()} 모두의오늘. All rights reserved.
      </footer>
    </div>
  );
}
